import { Alert } from 'bootstrap';

export function initAlerts() {
  if ($('#flash-notice .alert-body').html()) {
    $('#flash-notice').toggleClass('in');
    setTimeout(function () {
      new Alert(document.getElementById('flash-notice')).close();
    }, 80000);
  }
}